import React from 'react'
import className from 'classnames'

export const DropdownButton = (props) => {

  return <button onClick={props.onClick} className='generic-dropdown-button flex-1'>{props.children}</button>

}
